var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "customcheckerboard-style-selection row"
  }, [_vm.displayModels && _vm.$props.canvasLoaded ? [_c('h5', {
    class: ['customcheckerboard-main-views-wrapper-title', 'text-center']
  }, [_vm._v(_vm._s(_vm.translations.customCheckerboardStyleTitle))]), _vm._l(_vm.styles, function (style) {
    return _c('button', {
      key: style.model,
      staticClass: "style-button columns small-6 medium-4",
      attrs: {
        "disabled": !_vm.enableControls
      },
      on: {
        "click": function click($event) {
          return _vm.selectStyle(style);
        }
      }
    }, [_c('div', {
      staticClass: "style-button-svg"
    }, [_c('svg-renderer', {
      attrs: {
        "isSvgSelected": _vm.selectedStyle === style.model,
        "images": _vm.images[style.model],
        "model": style.model,
        "view": style.svg_view,
        "enableSmartcrop": false,
        "package": "customcheckerboard"
      },
      on: {
        "isLoading": _vm.setLoadedSvg,
        "svgSelected": _vm.selectModel
      }
    })], 1), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: style.model === _vm.selectedStyle,
        expression: "style.model === selectedStyle"
      }],
      staticClass: "customcheckerboard-style-selection-selected",
      attrs: {
        "src": "https://www.vans.com/vans-customs-assets-prod/assets/svg/customizer/icon-checkmark-inside-circle.svg"
      }
    }), _c('span', {
      staticClass: "style-button-name"
    }, [_vm._v(_vm._s(style.name))])]);
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }